(($) => {

    /**
     * Gulp include scripts
     *
     * @link https://www.npmjs.com/package/gulp-include
     */
    //=require ../../template-parts/blocks/example/block-example.js

    /**
     * jQuery Document Ready
     *
     * @link https://learn.jquery.com/using-jquery-core/document-ready/
     */
    $(() => {
        if ($('.logo-slider').length) {
            $('.logo-slider').slick({
                infinite: true,
                slidesToShow: 8,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: 0,
                arrows: false,
                speed: 8000,
                pauseOnHover: false,
                cssEase: 'linear',
                prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"></button>',
                nextArrow: '<button type="button" class="slick-next" aria-label="Next"></button>'
            });
        }

        var isPaused = false;
        $('.js-pause-logo-slider').on('click', function () {
            if (isPaused) {
                $('.logo-slider').slick('slickPlay');
                isPaused = false;
            } else {
                $('.logo-slider').slick('slickPause');
                isPaused = true;
            }
        });

        if ($('.card-slider').length) {
            $('.card-slider').slick({
                dots: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><rect width="32" height="32" rx="16" transform="matrix(-1 0 0 1 32 0)" fill="#0AFFBA"/><path d="M18 10L12 16L18 22" stroke="#202226" stroke-width="2"/></svg></button>',
                nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none"><rect width="32" height="32" rx="16" fill="#0AFFBA"/><path d="M14 10L20 16L14 22" stroke="#202226" stroke-width="2"/></svg></button>'
            });
        }

        jQuery(document).on('gform_post_render', function(event, form_id, current_page){
            if ($('#gform_3_validation_container').length > 0 || $('#gform_confirmation_message_3').length > 0) {
                $('#pop-up').addClass('active');
                $('body').addClass('no-scroll');
            }

			var formHandler = {
				urlFields: $('.js-gform input[type=url]'),

				init: function() {
					this.bindEvents();
				},
				bindEvents: function() {
					let _self = this;
					this.urlFields.on('blur', function() {
						const normalized = _self.normalizeUrl($(this).val());
						$(this).val(normalized);
					});
					$('form[id^="gform_"]').on('submit', function() {
						_self.urlFields.each(function() {
							const normalized = _self.normalizeUrl($(this).val());
							$(this).val(normalized);
						});
					});
				},

				// Normalize URL:
				// Enforce "https://" prefix if protocol is missing.
				normalizeUrl: function(value) {
					const trimmed = value.trim();
					if(!trimmed) { return trimmed; }
					if(!/^https?:\/\//i.test(trimmed)) {
						return 'https://' + trimmed;
					}
					return trimmed;
				},
			};
			formHandler.init();
        });
    });

})(jQuery);

// Add active class to forms if input is on focus or has value
const gformInputs = document.querySelectorAll(
    '.js-gform input[type=text], .js-gform input[type=email], .js-gform input[type=url]'
);

gformInputs.forEach(input => {
    if (input.value.length) {
        input.closest('.gfield').classList.add('active');
    }

    input.addEventListener('focus', () => {
        input.closest('.gfield').classList.add('active');
    });

    input.addEventListener('blur', () => {
        if (!input.value.length || input.value.includes('_')) {
            input.closest('.gfield').classList.remove('active');
        }
    });
});

document.querySelectorAll('.js-gform select').forEach(select => {
    select.addEventListener('change', () => {
        select.closest('.gfield').classList.toggle('active', select.value !== '');
    });
});

// Pop-up open
document.querySelectorAll('.js-popup-open').forEach(button => {
    button.addEventListener('click', () => {
        document.querySelector('#pop-up').classList.add('active');
        document.body.classList.add('no-scroll');
    });
});

// Pop-up close
document.querySelectorAll('.js-popup-close').forEach(button => {
    button.addEventListener('click', () => {
        document.querySelector('#pop-up').classList.remove('active');
        document.body.classList.remove('no-scroll');
    });
});

// Pop-up video
const overlay = document.getElementById('videoOverlay');
const iframe = document.getElementById('videoIframe');

function openModal() {
    overlay.classList.add('open');
}
function closeModal() {
    overlay.classList.remove('open');
}

document.querySelectorAll('.js-play-video').forEach(el =>
    el.addEventListener('click', openModal)
);
document.getElementById('closeModal').addEventListener('click', closeModal);
overlay.addEventListener('click', e => { if (e.target === overlay) closeModal(); });
document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });
